angular
	.module 'App'
	.provider 'UserInformation', ->
		users =
			master_user: null
			sub_user: null

		@config = (masterUser, subUser) ->
			users.master_user = angular.copy masterUser
			users.sub_user = angular.copy subUser

		@$get = [
			-> {
				clear: ->
					users.master_user = null
					users.sub_user = null
				setResources: (masterUser, subUser) ->
					users.master_user = angular.copy masterUser
					users.sub_user = angular.copy subUser
				getMasterUser: -> users.master_user
				getSubUser: -> users.sub_user
			}
		]

		return
